<template>
    <v-form v-model="validForm">
        <v-card>
            <v-toolbar color="primary" dark flat style="z-index:1;">
                <v-toolbar-title v-if="isNew">Crea nuovo progetto</v-toolbar-title>
                <v-toolbar-title v-else-if="disabled">Progetto "{{ value.name }}"</v-toolbar-title>
                <v-toolbar-title v-else>Modifica progetto "{{ value.name }}"</v-toolbar-title>

                <v-spacer></v-spacer>
                <v-speed-dial v-if="!isNew && !disabled" direction="bottom">
                    <template v-slot:activator>
                        <v-btn dark icon>
                            <v-icon>
                                more_vert
                            </v-icon>
                        </v-btn>
                    </template>
                    <delete-btn small fab="true" :icon="false" dark color="red" :action="'/projects/' + data.id"
                        confirm-message="Sei sicuro di voler eliminare questo progetto e tutti i dati ad esso riferiti?"><v-icon>delete</v-icon></delete-btn>
                </v-speed-dial>

            </v-toolbar>
            <error-badge v-model="error" ref="errors" class="ma-4"></error-badge>
            <v-list two-line>
                    <v-list-item>
                    <v-list-item-content v-if="disabled">
                        <v-list-item-title>{{ data.code }}</v-list-item-title>
                        <v-list-item-subtitle>Codice progetto</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content v-else>
                        <v-text-field
                            label="Codice progetto"
                            v-model="data.code"
                            :rules="[onlyNumbers]"
                            maxlength="10"
                            @keypress="onlyDigits"
                        />
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content v-if="disabled">
                        <v-list-item-title>{{ data.name }}</v-list-item-title>
                        <v-list-item-subtitle>Nome progetto</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content v-else>
                        <v-text-field v-model="data.name" dense :rules="rules.name"
                            label="Nome progetto"></v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                    <v-list-item-content v-if="disabled">
                        <v-list-item-title>{{ data.description }}</v-list-item-title>
                        <v-list-item-subtitle>Descizione progetto</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content v-else>
                        <v-text-field v-model="data.description" dense :rules="rules.description"
                            label="Descrizione progetto"></v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                    <v-list-item-content v-if="disabled">
                        <v-list-item-title>{{ data.customer && data.customer.name }}</v-list-item-title>
                        <v-list-item-subtitle>Cliente</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content v-else>
                        <item-selector v-model="data.customer" action="/customers/list" dense :rules="rules.customer"
                            label="Cliente">
                            <template v-slot:selection="{ item }">
                                <v-chip>{{ item.name }}</v-chip>
                            </template>
                            <template v-slot:item="{ item }">       
                                 <v-chip>{{ item.name }}</v-chip>
                            </template>
                        </item-selector>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>

                <v-list-item>
                    <v-list-item-content v-if="disabled">
                        <v-list-item-title>{{ data.project_manager && data.project_manager.name }}</v-list-item-title>
                        <v-list-item-subtitle>Project Manager</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content v-else>
                        <v-select v-model="data.project_manager_id" dense :items="resources" item-text="name" item-value="id" clearable
            label="Project Manager"></v-select>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>

                <div v-if="permissions.includes('view_projects_client_price')">
                    <v-list-item>
                        <v-list-item-content v-if="disabled">
                            <v-list-item-title>{{ data.client_price | euro }}</v-list-item-title>
                            <v-list-item-subtitle>Prezzo al cliente</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-content v-else>
                            <float-input :disabled="!permissions.includes('edit_projects_client_price')" prepend-icon="euro" v-model="data.client_price" label="Prezzo al cliente" :decimals="2" :rules="costRules"></float-input>
                        </v-list-item-content>
                    </v-list-item>

                    <v-divider></v-divider>
                </div>

 

                <v-list-item>
                    <v-list-item-content v-if="disabled">
                        <v-list-item-title>{{ data.date_start | date }}</v-list-item-title>
                        <v-list-item-subtitle>Data inizio</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content v-else>
                        <v-text-field type="date" v-model="data.date_start" dense :rules="rules.date_start" clearable
                            label="Data inizio"></v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                    <v-list-item-content v-if="disabled">
                        <v-list-item-title>{{ data.date_end | date }}</v-list-item-title>
                        <v-list-item-subtitle>Data fine</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content v-else>
                        <v-text-field type="date" v-model="data.date_end" dense :rules="rules.date_end" clearable
                            label="Data fine"></v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>

                <v-list-item>
                    <v-list-item-content v-if="disabled">
                        <v-list-item-title>

                            <template v-if="data.active"><v-icon color="success">check_circle</v-icon> Attivo</template>

                            <template v-else><v-icon color="error">cancel</v-icon> Inattivo</template>
                        </v-list-item-title>
                        <v-list-item-subtitle>Stato</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content v-else>
                        <v-switch v-model="data.active" label="Attivo"></v-switch>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content v-if="disabled">
                        <v-list-item-title>

                            <template v-if="data.completed"><v-icon color="success">check_circle</v-icon>
                                Completed</template>

                            <template v-else><v-icon color="error">cancel</v-icon> In corso</template>
                        </v-list-item-title>
                        <v-list-item-subtitle>Stato</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content v-else>
                        <v-switch v-model="data.completed" label="Completato"></v-switch>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-card-text>
                <v-alert v-if="isNew" color="purple" outlined border="left" :value="true">
                    {{ trans('document-checklist.disabled-on-new') }}</v-alert>
                <document-checklist v-else v-model="data" v-bind="{ disabled, loading: isLoading }" class="ma-2 mt-4"/>
            </v-card-text>
            <v-divider></v-divider>

            <v-card-text>
                <project-tasklist v-bind="{ disabled, loading: isLoading, value: data, showPrices, permissions, user }" class="ma-2 mb-4"
                    @show-subtask-event="showSubtaskEvent"></project-tasklist>
                <!-- <project-tasklist v-bind="{ disabled, loading: isLoading, value:data, }" class="ma-2 mb-4"></project-tasklist> -->
                <project-addictional-costs v-if="permissions.includes('view_project_additional_costs')" v-bind="{ disabled:!permissions.includes('edit_project_additional_costs'), loading: isLoading, value: data, permissions }" @update-addictional-costs="updateAddictionalCosts" class="ma-2 mt-4"/>
                <project-totals ref="totals"
                    v-bind="{ disabled, loading: isLoading, value: data, showPrices, projectInfo, permissions }" class="ma-2 mt-4" />
                <project-calendar ref="calendar" :date.sync="selectedDate"
                v-bind="{ disabled, loading: isLoading, value: data, }" class="ma-2 mt-4"></project-calendar>
            </v-card-text>
            <v-card-actions v-if="!disabled">
                <v-spacer></v-spacer>
                <v-btn color="primary" :disabled="!canSubmit" :loading="loading" @click="submit"><v-icon>save</v-icon>
                    Salva</v-btn>
            </v-card-actions>
            <v-snackbar v-model="submittedSnackbar" color="success" :timeout="2000">Progetto aggiornato correttamente!

                <template v-slot:action="{ attrs }">
                    <v-btn icon v-bind="attrs" @click="submittedSnackbar = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </template>
            </v-snackbar>
        </v-card>
    </v-form>
</template>

<script>
import { Vuelidator, Rule } from '../Vuelidator/index.js';
import { NormalizeProject, calculateProjectInfo } from './ProjectGantt/ProjectUtils.js';

import ProjectTasklist from './ProjectGantt/ProjectTasklist.vue';
import ProjectCalendar from './ProjectGantt/ProjectCalendar.vue';
import ProjectTotals from './ProjectGantt/ProjectTotals.vue';
import ProjectAddictionalCosts from './ProjectGantt/ProjectAddictionalCosts.vue';
import DocumentChecklist from './ProjectGantt/DocumentChecklist.vue';


export default {
    props: {
        value: { required: false, type: Object },
        resources: { required: false, type: Array },
        disabled: { default: false },
        showPrices: { type: Boolean, default: true },
        permissions: {type: Array, default: () => []},
        user:{type:Object, required: true},
    },
    data() {
        const data = NormalizeProject(this.value);
        const validator = new Vuelidator({
            name: [Rule.required(), Rule.min(3)],
            customer: [Rule.required(),],
            customer_id: [Rule.required(), Rule.numeric(), Rule.min(0)],
            description: [Rule.nullable(), Rule.min(3)],
            date_start: [Rule.nullable(), Rule.date()],
            date_end: [Rule.nullable(), Rule.date()],
        });
        const rules = validator.getRules();
        return {
            data,

            validForm: false,
            loading: false,

            error: null,
            hasChanged: false,
            submittedSnackbar: false,

            selectedDate: moment().format('YYYY-MM-DD'),
            rules,
            costRules: [
                v => !isNaN(v) && v >= 0 || 'Il costo deve essere un numero maggiore di zero',
            ],
        }
    },
    mounted() {
    },
    computed: {
        canSubmit() { return this.validForm; },
        isLoading() { return this.loading; },
        isNew() { return !this.data.id; },
        projectInfo() {
            return calculateProjectInfo(this.data);
        },
    },
    methods: {
        onlyDigits(event) {
            const charCode = event.charCode;
            // Consenti solo i codici ASCII tra 48 ('0') e 57 ('9')
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        },
        onlyNumbers(val) {
            return /^\d*$/.test(val) || "Inserisci un codice corretto";
        },
        async submit() {
            //todo
            const _method = this.isNew ? 'post' : 'patch';
            const action = this.isNew ? '/projects' : '/projects/' + this.data.id + '';
            const data = Object.assign({
                _method,
                project_info: this.projectInfo,
            }, this.data);

            this.loading = true;
            this.error = null;
            try {

                const res = await axios.post(action, data);
                if (!res.data || res.data.result !== 'ok') {
                    throw new Error((res.data && res.data.message) || 'Errore: risposta invalida!');
                }

                this.$emit('submitted');
                this.submittedSnackbar = true;
                if (res.data.redirect) {
                    window.onbeforeunload = null;
                    location.href = res.data.redirect;
                    this.$nextTick(() => this.loading = true);
                }
                //TODO: submitted
            } catch (e) {
                this.error = e;
                this.$nextTick(() => this.$vuetify.goTo(this.$refs.errors, {}));
            }
            this.loading = false;
        },
        editProject() {
            location.href = '/projects/' + this.data.id + '/edit';
        },
        showSubtaskEvent(subTask) {
            this.selectedDate = subTask.date_start;
            this.$vuetify.goTo(this.$refs.calendar, {});
        },
        updateAddictionalCosts(value){
            this.data.addictional_costs = value;
        },
        suggestCode() {
            if (!this.data.customer_id) {
                return;
            }

            this.loading = true;

            axios.post('/projects/generate-code', { customer_id: this.data.customer_id })
                .then(response => {
                    if (response.data?.code) {
                        this.data.code = response.data.code;
                    }
                })
                .catch(error => {
                    console.error('Errore nella generazione del codice:', error);
                }).finally(() => {
                    this.loading = false;
                });
        }
    },
    watch: {
        data: {
            deep: true,
            handler() {
                this.hasChanged = true;
                window.onbeforeunload = function () {
                    return 'Sei sicuro di voler chiudere la pagina perdendo TUTTI i dati inseriti?';
                };
            }
        },
        'data.customer': function () {
            this.data.customer_id = this.data.customer ? this.data.customer.id : null;
        },
        'data.customer_id': function () {
            if(this.data.customer_id && !this.data.code && this.isNew) {
                this.suggestCode();
            }
        },
    },
    filters: {},
    components: {
        ProjectTasklist,
        ProjectCalendar,
        ProjectTotals,
        DocumentChecklist,
        ProjectAddictionalCosts
    },
}
</script>
